var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIconBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1376 15.0379L18.7719 17.6722C19.076 17.9755 19.076 18.4686 18.7719 18.7719C18.4686 19.076 17.9763 19.076 17.6722 18.7719L15.0379 16.1376C13.984 16.9566 12.6602 17.4443 11.2221 17.4443C7.78596 17.4443 5 14.6583 5 11.2221C5 7.78596 7.78596 5 11.2221 5C14.6583 5 17.4443 7.78596 17.4443 11.2221C17.4443 12.6602 16.9566 13.984 16.1376 15.0379ZM6.55495 11.2223C6.55495 13.7999 8.64403 15.8889 11.2215 15.8889C13.7991 15.8889 15.8882 13.7999 15.8882 11.2223C15.8882 8.64483 13.7991 6.55575 11.2215 6.55575C8.64403 6.55575 6.55495 8.64483 6.55495 11.2223Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconBlack);
export default __webpack_public_path__ + "static/media/search-icon-black.e8e07432948f833094c7c622bddf55b8.svg";
export { ForwardRef as ReactComponent };